module.exports = __webpack_public_path__ + "static/media/iconActivitiesActive.edd3e87f.svg";